import { AppRadio } from '@/shared/ui/radio'
import { Icon, TIconVariant } from '../../shared/ui/icon'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { changeSubscriptionPaymentOption } from '@/entities/payments'
import { $selectedSubscriptionOption, SubscriptionPaymentOptions } from '@/entities/payments'

type SubscriptionOptionProps = {
  variant: SubscriptionPaymentOptions
}

export const SubscriptionOption = (props: SubscriptionOptionProps) => {
  const { variant = 'plus' } = props
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const selectedOption = useUnit($selectedSubscriptionOption)
  const texts = lang[userLang].pages.main.subscriptionDrawer
  const iconImg: TIconVariant = variant === 'plus' ? 'plusLogo' : 'platinum'
  return (
    <div
      className={classes.root}
      data-isselected={variant === selectedOption}
      data-variant={variant}
      onClick={() => changeSubscriptionPaymentOption(variant)}
    >
      <div className={classes.radioWrapper}>
        <AppRadio isSelected={selectedOption === variant} />
      </div>
      <div className={classes.iconsContainer}>
        <img
          src="/assets/subscriptionRelated/gamedLogo.webp"
          height={19}
          alt=""
        />
        <Icon
          view={iconImg}
          style={{ alignSelf: 'center', width: '60px' }}
        />
      </div>
      {variant === 'platinumDiscount' && (
        <div className={classes.bottomContainer}>
          <span>{texts.add}</span>
          <Icon
            view="gamedCoin"
            width={16}
            style={{ alignSelf: 'center' }}
          />
          <span>{texts.toGet}</span>
          <span
            style={{
              background: 'linear-gradient(131deg, #FFC926 -2.34%, #FFF5A9 103.12%)',

              backgroundClip: 'text',

              WebkitBackgroundClip: 'text',

              WebkitTextFillColor: 'transparent',
            }}
          >
            {texts.discount}
          </span>
        </div>
      )}
    </div>
  )
}
